define('ordersDetailOrderView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'itemPagesNameMixin',
  'ordersDetailOrderProductView',
  'ordersDetailOrderPrintZonesView',
  'ordersDetailOrderHistoryView',
  'ordersDetailOrderClientView',
  'ordersDetailOrderStatusView',  
  'ordersDetailOrderCommentsView',
  'template!ordersDetailOrderView'
], function (
  App,  
  Module,
  Marionette,
  _,
  ItemPagesNameMixin,
  ProductView,
  PrintZonesView,
  HistoryView,
  ClientView,
  StatusView,
  CommentsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-order-view',       

    regions: {
      productRegion: '.product-region',
      historyRegion: '.history-region',
      clientRegion: '.client-region',
      statusRegion: '.status-region',
      commentsRegion: '.comments-region',
      printZonesRegion: '.print-zones-region'
    },

    initialize: function() {
      if (this.model && this.model.get('order') && this.model.get('order').get('commandType')) {
        if(this.model.get('order').get('commandType') === 'offer')
          App.execute('set:active:nav:item', ItemPagesNameMixin.OFFERS_BOARD, false);
        else
          App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_BOARD, false);
      }
    },          
   
    onShow: function() {       
      this.productView = new ProductView({
        model: this.model.get('order'),        
        product: this.model.get('product')        
      });
      this.getRegion('productRegion').show(this.productView);

      //-------------------
      this.printZonesView = new PrintZonesView({
        model: this.model.get('order'),        
        product: this.model.get('product')      
      });      
      this.getRegion('printZonesRegion').show(this.printZonesView);      

      //-------------------
      this.commentsView = new CommentsView({
        model: this.model.get('order'),        
        product: this.model.get('product')        
      });
      this.getRegion('commentsRegion').show(this.commentsView);     

      //-------------------
      this.clientView = new ClientView({
        model: this.model.get('order'),
        customer: this.options.customer,
        product: this.model.get('product')    
      });
      this.getRegion('clientRegion').show(this.clientView);

      //-------------------

      this.statusView = new StatusView({
        model: this.model.get('order'),
        customer: this.options.customer
      });
      this.getRegion('statusRegion').show(this.statusView);     

      //-------------------
      this.historyView = new HistoryView({
        model: this.model.get('order')
      });
      this.getRegion('historyRegion').show(this.historyView);      
    }
  });
});
